import { Phone as o } from "./phone.js";
import { Laptop as r } from "./laptop.js";
import { Desktop as m } from "./desktop.js";
import { Monitoring as t } from "./monitoring.js";
import { Tablet as i } from "./tablet.js";
import { Watch as p } from "./watch.js";
import { Watch2 as f } from "./watch-2.js";
import { Fitbit as e } from "./fitbit.js";
import { Pos as s } from "./pos.js";
import { PosLarge as a } from "./pos-large.js";
import { PosTalk as n } from "./pos-talk.js";
import { Printer as P } from "./printer.js";
import { PosMedium as c } from "./pos-medium.js";
import { PosPlatform as h } from "./pos-platform.js";
import { Atm as l } from "./atm.js";
import { TerminalFleetManager as T } from "./terminal-fleet-manager.js";
import { PosInterfacesShopperExperience as d } from "./pos-interfaces-shopper-experience.js";
import { PosTestingTools as g } from "./pos-testing-tools.js";
import { Kiosk as W } from "./kiosk.js";
import { Webinar as b } from "./webinar.js";
import { PosGood as k } from "./pos-good.js";
import { PosWrong as y } from "./pos-wrong.js";
import { PosAndroid as A } from "./pos-android.js";
import { Display as D } from "./display.js";
import { Keypad as M } from "./keypad.js";
import { CashRegister as x } from "./cash-register.js";
import { PhoneAndWatch as F } from "./phone-and-watch.js";
import { TapToPay as K } from "./tap-to-pay.js";
const mo = {
  Phone: o,
  Laptop: r,
  Desktop: m,
  Monitoring: t,
  Tablet: i,
  Watch: p,
  Watch2: f,
  Fitbit: e,
  Pos: s,
  PosLarge: a,
  PosTalk: n,
  Printer: P,
  PosMedium: c,
  PosPlatform: h,
  Atm: l,
  TerminalFleetManager: T,
  PosInterfacesShopperExperience: d,
  PosTestingTools: g,
  Kiosk: W,
  Webinar: b,
  PosGood: k,
  PosWrong: y,
  PosAndroid: A,
  Display: D,
  Keypad: M,
  CashRegister: x,
  PhoneAndWatch: F,
  TapToPay: K
};
export {
  mo as Devices40
};
